{
    "Api tokens": {
        "add token": "添加令牌",
        "description": "生成用于TCT和Configurator的OEM文件下载API令牌，或生成应用程序请求FOTA WEB服务时使用的API令牌。API文档详见<1>此处</1>。",
        "example": "例如：fota_token",
        "generate token": "生成令牌",
        "generated token": "生成的令牌",
        "last used at": "最后使用于",
        "name": "令牌名称",
        "never": "永不",
        "no tokens": "暂无可用令牌",
        "no tokens description": "添加令牌后，它们将显示在下方列表中",
        "show token list": "显示令牌列表",
        "titles": {
            "Integration": {
                "description": "用于在您的系统中集成FOTA WEB功能",
                "name": "API集成令牌"
            },
            "Tct": {
                "description": "用于TCT和Configurator的OEM文件下载",
                "name": "TCT令牌"
            }
        },
        "tokens": "API 令牌",
        "token type": "令牌类型",
        "token was created": "令牌已成功创建"
    },
    "Attributes": {
        "Completed": "已完成",
        "Count": "计数",
        "Current": "当前",
        "Date": "日期",
        "Empty": "空",
        "excluded files": "排除文件（同级）",
        "Failed": "失败",
        "false": "",
        "Feature": "功能",
        "file size bytes": "总文件大小",
        "File_type": "文件类型",
        "File_version": "文件版本",
        "Fingerprint_id": "指纹识别",
        "Firmware_date": "固件日期",
        "Firmware_version": "修订版",
        "included files": "包含文件",
        "Include_j1939": "",
        "Message": "消息",
        "Metadata": "",
        "newest": "最新版本",
        "oldest": "按时间排序",
        "Order": "订单",
        "Password_source": "",
        "Pending": "待处理",
        "Period": "周期",
        "Process_id": "",
        "Protocol_id": "协议ID",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "具体",
        "Start": "开始",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE固件",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN固件",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP固件"
        },
        "UserEntered": "",
        "vehicle": "车辆",
        "Vehicle_id": "车辆识别码",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "请检查您的身份验证应用",
            "check email": "请查收您的电子邮件",
            "code required": "需验证码。",
            "code sent to email": "代码已发送至您的邮箱",
            "code valid": "该代码有效期为数分钟。",
            "enter code below": "请输入下方验证码登录。",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "需验证码登录。请在验证器应用中查看验证码，并在下方输入以完成登录。",
        "check email": "请检查您的收件箱，点击收到的链接重置密码。",
        "community forum": "社区支持论坛",
        "contact us": "联系我们",
        "create initial password": "创建密码",
        "create password": "创建一个密码",
        "did not receive": "未收到链接？",
        "do not have account": "还没有账户？",
        "email": "电子邮件",
        "enter email": "请在下方输入您注册的邮箱地址，以接收密码重置说明。",
        "forgot password": "忘记密码？",
        "forgot your password": "忘记密码？",
        "for ms365": "适用于Teltonika MS365用户",
        "invalid email format": "无效的电子邮件格式",
        "invalid password format": "密码格式无效",
        "link sent": "链接已发送！",
        "length": "至少8个字符",
        "lowercase": "至少包含1个小写字母",
        "new password": "新密码",
        "password": "密码",
        "passwords do not match": "密码不匹配",
        "privacy policy": "使用FOTA WEB即表示您同意我们的<1>隐私政策</1>。",
        "remember password": "您记得您的密码吗？",
        "repeat password": "重复密码",
        "required": "必需的",
        "resend": "重新发送",
        "reset password": "重置密码",
        "send reset link": "发送重置链接",
        "sign in": "登录",
        "sign in to fota": "登录您的FOTA WEB账户",
        "signup": "立即注册",
        "sso": "使用 Microsoft 帐户登录",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "大写字母",
        "user consent text": "本人理解并接受Teltonika的<1>服务条款</1>及<2>数据处理协议</2>。",
        "welcome": "欢迎来到",
        "wiki": "Telematics Wiki 远程信息处理维基知识库"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "接受",
        "accept all": "接受所有",
        "accept selected": "接受所选",
        "actions": "操作",
        "add": "添加",
        "add device": "添加设备",
        "add more files": "添加更多文件",
        "add new": "添加新设备",
        "agree": "我同意",
        "all companies": "所有企业",
        "all of company": "{{companyName}}旗下所有产品",
        "all rows selected": {
            "devices": "已选中全部 {{count}} 台设备",
            "tasks": "所有 {{count}} 个待处理/正在运行的任务均被选中",
            "groups": "所有 {{count}} 个组均已选中",
            "files": "已选中全部 {{count}} 个文件",
            "companies": "已选中全部{{count}}家公司",
            "users": "所有 {{count}} 名用户均已选定"
        },
        "approve": "批准",
        "assign": "分配",
        "assigning": "分配中",
        "auto sync": "",
        "back": "返回",
        "back to sign in": "返回登录页面",
        "cancel": "取消",
        "cancelling": "取消中",
        "cancel all tasks in group": "取消组内所有任务",
        "cancel tasks": "取消任务",
        "cannot create desktop licenses": "不支持为内部公司创建许可证。",
        "cannot create offline licenses": "不支持为无限制许可证创建离线许可证。",
        "change": "变更",
        "clear all": "清除所有",
        "clear all filters": "清除所有筛选条件",
        "close": "关闭",
        "company settings": "公司设置",
        "confirm": "确认",
        "continue": "继续",
        "copied": "复制",
        "copy all": "",
        "copy to clipboard": "复制到剪贴板",
        "create": "创建",
        "create role": "创建角色",
        "create task": "创建任务",
        "creating": "创建",
        "default view": "默认视图",
        "delete": "删除",
        "deleting": "删除中",
        "deselect all": "取消全选",
        "device": "设备",
        "disable": "禁用",
        "disagree": "我不同意",
        "discard": "弃用",
        "download": "",
        "edit": "编辑",
        "enable": "启用",
        "export": "导出",
        "exporting": "导出中",
        "filters": "过滤器",
        "finish": "",
        "find tool": "查找工具",
        "first page": "首页",
        "generate": "生成",
        "generate codes": "",
        "go back": "返回",
        "import": "导入",
        "importing": "导入中",
        "invite": "邀请",
        "invite user": "邀请用户",
        "invite user to internal disabled": "仅管理员及更高权限级别可邀请用户加入内部公司。",
        "language": "语言",
        "last page": "上一页",
        "logout": "退出登录",
        "maximize details": "最大化细节",
        "merge": "合并",
        "merging": "合并中",
        "minimize details": "尽可能简化细节",
        "more actions": "更多操作",
        "more filters": "更多筛选条件",
        "more options": "更多选项",
        "move": "移动",
        "moving": "迁移中",
        "next": "Next",
        "next month": "下个月",
        "next page": "下一页",
        "no actions available": "无可用操作",
        "no permission": "您需要\"{{permissionName}}\"权限。",
        "no permissions": "您需要以下权限：{{permissionNames}}。",
        "notify when done": "操作完成后通知我",
        "number of selected companies": "{{companyCount}}的{{companyName}}",
        "only essential": "仅保留核心功能",
        "open fota web": "开放FOTA WEB",
        "pages of": "共 {{total}} 项",
        "previous month": "上个月",
        "previous page": "上一页",
        "print": "",
        "receive devices": "接收设备",
        "refresh page": "刷新",
        "reject all": "拒绝所有",
        "reset to default": "重置为默认设置",
        "retry failed tasks": "重试失败任务",
        "retrying": "重试",
        "return home": "回到主页",
        "revert manual level change": "撤销手动层级变更",
        "rows count per page": "每页行数",
        "rows selected": "{{count}} 已选",
        "save": "保存",
        "saving": "",
        "see all": "查看全部",
        "select all": {
            "devices": "全选 {{count}} 台设备",
            "tasks": "选中所有 {{count}} 个待处理/正在运行的任务",
            "groups": "全选 {{count}} 个组",
            "files": "全选 {{count}} 个文件",
            "companies": "选中所有 {{count}} 家公司",
            "users": "全选 {{count}} 个用户"
        },
        "select columns to show": "选择要显示的列",
        "selected page is first": "所选页面为首页",
        "selected page is last": "所选页面为最后一个页面",
        "select rows": "选择行",
        "send code": "发送代码",
        "settings": "设置",
        "show me": "展示给我",
        "show more": "显示更多",
        "synchronize": "同步",
        "table statistics": "表统计",
        "table view": "表格视图",
        "transfer": "转移",
        "transferring": "转移中",
        "transfer my devices": "转移我的设备",
        "undo": "撤销",
        "upload": "上传",
        "upload file": "上传新文件",
        "user": "用户",
        "verify": "验证",
        "yes": "是"
    },
    "Cookies": {
        "always active": "始终处于活动状态",
        "analytics cookies": "分析Cookie",
        "analytics cookies description": "这些跟踪工具用于分析，以帮助收集数据，使我们能够了解用户如何与我们的网站互动。这些洞察不仅有助于我们优化内容，还能帮助我们开发更好的功能，从而提升用户体验。此类 Cookie 可以被禁用。",
        "cookie banner message": "我们及选定的第三方会出于技术目的使用Cookie或类似技术，并在您同意的情况下，用于《隐私政策》中规定的其他用途。",
        "cookie modal title": "我们使用Cookie",
        "cookie policy": "Cookie政策",
        "essential cookies": "必要Cookie",
        "essential cookies description": "这些追踪器仅用于执行您向我们请求的服务所必需的操作，不会收集可用于营销目的的个人信息，也不会记录您的网络浏览历史。此类Cookie无法被禁用。"
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "远程设备更新必备工具",
                "Standard": "高级自动化与集成",
                "Premium": "支持企业级扩展，并可优先获取更新版本"
            },
            "resource limit types": {
                "Companies": "企业",
                "Users": "用户",
                "ConfigurationFiles": "配置文件"
            }
        },
        "empty state": {
            "description": {
                "configurations": "当FOTA WEB检测到配置时，您即可在此处查看列表。",
                "firmware versions": "当FOTA WEB检测到固件版本时，您将在此处看到列表。"
            },
            "title": {
                "configurations": "未检测到任何配置",
                "firmware versions": "未检测到固件版本",
                "news": "暂无内容可显示"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "今日",
                "7": "7天",
                "30": "30天",
                "90": "90天"
            },
            "period": "周期"
        },
        "new": "",
        "news": {
            "body": {
                "1": "谨此提醒：2025年1月7日后邀请的用户，账户激活时将立即强制启用双重认证（2FA）。您可通过电子邮件验证或认证应用程序完成双重认证。",
                "2": "特此通知，FOTA WEB系统计划于2025年6月3日协调世界时05:00开始进行维护。请注意，维护期间所有服务将暂停，包括用户界面、API访问、任务执行、OBD及CAN服务。预计服务中断时长为1小时。",
                "3": "<section><p>我们很高兴宣布FOTA WEB平台的设备解锁功能迎来重大升级：</p></section> <section><p>所有用户角色现可直接解锁设备——无需通过服务台联系技术支持！</p> <p>核心功能：</p> <ul><li>用户可在24小时内对同一设备解锁最多3次。</li> <li>达到上限后，解锁选项将暂时禁用24小时。</li> <li>若超出解锁次数限制，系统将显示错误提示。本次更新显著缩短等待时间，让您更高效掌控车队管理。</li></ul></section> <section><a>了解功能使用方法</a></section>",
                "4": "<section><h3>全新设备统计功能</h3> <p>借助两款全新小工具，更深入地了解设备活动：</p> <p><strong>激活设备</strong>： 此统计数据可显示不同时间段内激活（连接）的设备数量：今日、7天、30天或90天。</p> <p><strong>导入设备</strong>：同理，新增的导入设备统计将追踪今日、7天、30天或90天内导入的设备数量。</p> </section> <section><h3>任务小部件介绍</h3> <p>通过全新任务小部件掌握运营动态：</p> <p><strong>待办任务</strong>：清晰查看当前待处理任务数量。</p> <p><strong>任务概览</strong>：按周期（7天、30天或90天）和状态查看任务分布详情。包括已完成、带错误完成或失败的任务。</p></section> <section><h3>更智能的固件与配置概览</h3> <p>我们优化了固件版本和配置小工具：</p> <ul><li>移除了\"未知\"统计项，使数据更清晰。</li> <li>界面现更清晰地显示固件与配置名称及其数量。</li> <li>初始显示前5个版本或配置，点击\"显示更多\"可查看最多100条不同条目。</li> <li>悬停或点击特定固件/配置将跳转至\"设备页面\"并应用筛选条件。</li></ul></section> <section><h3>增强版新闻小工具</h3> <p>一目了然，随时掌握最新动态！新闻小工具焕然一新，现在您还可以点击任何新闻项目阅读完整信息。</p></section> <section><h3>改进的设备状态</h3> <p>设备状态小工具已进行视觉更新，更清晰易读。 此外，您现在可将鼠标悬停在设备状态上，点击后即可在\"设备\"页面筛选出具有相同状态的设备。</p></section> <section><p>我们希望这些更新能让您的日常任务更轻松，并为您提供更有价值的信息。欢迎随时反馈您的想法！</p></section>",
                "5": "<section><h3>计划中的API变更</h3></section> <section><p>自<strong>2025年9月24日</strong>起，我们将移除返回用户实体响应中的\"role\"字段（例如GET /users或GET /users/{userId}接口）。此变更旨在为FOTA WEB构建更强大灵活的权限系统铺平道路。</p></section> <section><h3>抢先预览：角色与权限系统</h3></section> <section><p>我们意识到当前角色系统未能满足您的灵活性需求。开发团队正全力打造全新的<strong>角色与权限管理功能</strong>，您将能够创建具备精细化权限控制的角色。</p></section> <section><p>新系统将赋予您两大能力：为用户分配静态角色，或根据具体需求定制权限并创建自定义角色。我们对此充满期待，将在功能上线时分享更多关于角色与权限管理的详细信息。</p></section>",
                "6": "<section><p>我们很高兴宣布推出全新<strong>\"角色与权限\"</strong>功能，旨在让您精确控制FOTA WEB平台内的用户访问权限。该功能支持通过<strong>角色</strong>定义用户能力，这些角色由特定<strong>权限</strong>组合构成（例如\"创建任务\"、\"邀请用户\"）。 该功能包含不可更改的<strong>静态角色</strong>——管理员、用户和访客——以保障基础安全，同时提供可自定义的<strong>自定义角色</strong>，仅<strong>高级企业级</strong>用户可创建或编辑。权限现已按设备、任务和用户等关键领域分类，悬停管理区域的\"权限数量\"即可查看详情。 <strong>所有在此更新之前创建的现有用户均已自动被分配\"管理员\"角色，确保其保留此前可执行的全部操作权限。</strong></p></section> <section><p>本次更新可确保更佳的安全性与工作负载分配。 角色现为公司专属，不可跨公司结构继承。请注意：邀请或转移用户至公司时必须分配角色，且已分配给用户的活跃角色不可删除。您现在可在<strong>用户</strong>页面使用<strong>全新\"角色\"筛选器</strong>进行便捷管理。立即探索\"角色与权限\"部分，配置符合您组织需求的访问权限。</p></section> <section><p>有关用户与角色管理的详细指南，请访问<a>Wiki页面</a>。</p></section>",
                "7": "<section><p>我们很高兴推出<strong>按日期安排</strong>功能，为您提供管理任务的全新强大方式，让您对时间敏感的工作实现更高精度！</p></section> <section><h3>主要亮点</h3></section> <section><ul><li><strong>具体截止日期</strong> - 现在，您可以使用新的\"按日期安排\"选项，为任务安排<strong>具体日期或日期区间</strong>。</li> <li><strong>默认行为不变</strong> - 熟悉的<strong>按时间安排</strong>功能仍可完全使用。</li> <li><strong>过期状态</strong> - 未在设定日期前完成的任务将自动变为<strong>过期</strong>状态，并显示提示信息：<strong>\"该任务未在设定时间内完成。\"</strong></li> <li><strong>用户时区优先</strong> - 所有日程均基于<strong>您的本地时间</strong>创建。</li></ul></section> <section><h3>操作原理</h3></section> <section><p>设置任务<strong>\"按日期安排\"</strong>时：</p> <ul><li>您将通过日期选择器组件选择<strong>\"开始日期\"</strong>和<strong>\"结束日期\"</strong>。</li> <li>日期选择器遵循公司级任务过期时限。</li></ul></section><section><p><strong>按日期安排</strong>功能目前仅限高级公司层级使用，<strong>基础</strong>层级不可用。</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "自2025年1月7日起，新用户必须启用双因素认证（2FA）。",
                "2": "计划于2025年6月3日进行系统维护",
                "3": "新功能更新：所有用户均可更轻松地解锁设备",
                "4": "探索仪表盘上的最新动态！",
                "5": "重要提示：即将推出的API变更及角色权限功能预览",
                "6": "新功能现已上线：通过\"角色与权限\"实现增强控制",
                "7": "新功能：按日期安排任务计划，灵活性更强",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "发布于",
        "take me there": "带我去那里",
        "tasks": {
            "current": "当前",
            "status": {
                "completed": "已完成",
                "completed_with_errors": "已完成但存在错误",
                "failed": "失败",
                "no tasks": "无任务"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7天",
                "tooltipTitle": "过去7天"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30天",
                "tooltipTitle": "过去30天"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90天",
                "tooltipTitle": "过去90天"
            }
        },
        "title": {
            "activated": "已激活设备",
            "configurations": "配置",
            "device status": "设备状态",
            "firmware versions": "固件版本",
            "imported": "已导入设备",
            "news": "消息",
            "queued tasks": "队列任务",
            "refreshed every hour": "每小时刷新一次",
            "resource limits": "资源限制",
            "task overview": "任务概述",
            "tasks": "任务"
        },
        "tooltips": {
            "activated": "在所选时间段内首次连接至FOTA WEB的设备数量（今日、过去7天、过去30天、过去90天）。",
            "configurations": "展示已上传至设备的配置文件名分布情况。最多显示100个唯一文件名。",
            "firmware versions": "显示已连接设备报告的固件版本分布情况。最多可展示100个不同版本。",
            "imported": "所选时间段内（今日、过去7天、过去30天、过去90天）添加至您账户的设备数量。"
        }
    },
    "Date picker": {
        "disableFuture": "无效日期",
        "disablePast": "无效日期",
        "invalidDate": "无效日期",
        "maxDate": "日期错误",
        "minDate": "日期错误",
        "shouldDisableDate": "无效日期",
        "shouldDisableMonth": "无效日期",
        "shouldDisableYear": "无效日期"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "添加新设备",
        "add new device description": "向选定公司及组别添加单个或多个新设备。仅传统版版设备（例如 FM 或 FMA）需要通过勾选“导入为传统版设备（Import as legacy devices）”复选框来导入。",
        "add new device legacy title": "导入为传统设备。",
        "add new device legacy description": "将\"创建时间\"设为2016.01.01，\"型号\"设为Legacy。",
        "add new product code": "添加新产品代码",
        "add new product code description": "添加新的设备产品代码，并将其关联至可用的CAN配套。",
        "all permissions": "所有权限",
        "assign access group": "",
        "assign can package description": "选择配套类型并将其分配给所有选定设备。",
        "assign role": "分配角色",
        "attribute value": "属性值",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "开始下载",
        "by date": "按日期",
        "by time": "按时间",
        "can adapter": "CAN适配器",
        "cancel pending tasks": "取消相同任务类型的待处理任务",
        "cancel tasks": "取消任务",
        "cancel tasks in group": {
            "alert title": "此操作最多需要几分钟才能完成。",
            "banner description": "若需查看任务的最新状态，请查阅任务组详情或刷新页面。",
            "banner title": "此操作将耗时数分钟完成，具体时长取决于任务数量。",
            "description": "点击\"接受\"将取消所有待处理和正在运行的任务。您确定要继续吗？",
            "title": "取消该组内所有任务？"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "客户代表邮箱",
        "companies": "企业",
        "company": "公司",
        "company level": {
            "Basic": "基础版",
            "Internal": "内部",
            "Premium": "高级版",
            "Standard": "标准版"
        },
        "company level change description": "升级公司等级需选择新等级并说明原因。公司等级不可降级。所有日期均以UTC时间为准。",
        "company level manual revert": {
            "confirmation": {
                "description": "此操作将把公司层级重置为系统自动分配的层级\"{{companyLevel}}\"。是否确定继续？",
                "title": "撤销手动层级变更？"
            },
            "description": "还原操作将使公司层级恢复至系统自动分配的初始层级。",
            "title": "该企业级服务已手动升级至{{expirationDate}}。"
        },
        "company level type": "公司级类型",
        "company name": "公司名称",
        "company statistics": {
            "child companies": "子公司数量统计",
            "devices": "设备数量",
            "files": "文件数量",
            "groups": "设备组数量",
            "tasks": "任务计数",
            "users": "用户数量"
        },
        "company type": {
            "All": "",
            "Client": "客户端",
            "Internal": "内部",
            "Virtual": "虚拟"
        },
        "configuration": "配置",
        "confirmations": {
            "are you sure": "确定吗？",
            "are you sure you wish to continue": "您确定要继续吗？",
            "assign can package confirmation": "您确定要将所选套餐分配给指定数量的设备吗？",
            "cancel task confirmation": {
                "first part": "您确定要取消指定数量的任务吗？",
                "second part": "若存在此类任务，请输入受影响的任务数量并点击\"确认\"。"
            },
            "create task confirmation": "您确定要为指定数量的设备创建任务吗？",
            "delete resource confirmation": {
                "first part": "您确定要删除指定数量的{{resource}}吗？",
                "second part": "若需删除，请输入受影响的{{resource}}数量并点击\"删除\"。"
            },
            "delete resources": {
                "companies": "企业",
                "files": "文件",
                "groups": "设备组",
                "deviceModels": "模型",
                "productCodes": "产品代码",
                "roles": "角色",
                "users": "用户"
            },
            "description second part": "若确认，请输入受影响设备数量并点击\"确认\"。",
            "export device data confirmation": "您确定要为指定数量的设备导出设备数据吗？",
            "file": "输入文件中存在的行数",
            "filter": {
                "companies": "输入筛选后的公司数量",
                "devices": "输入过滤后的设备数量",
                "files": "输入过滤文件的数量",
                "groups": "输入过滤后的设备组数量",
                "productCodes": "输入过滤后的产品代码数量",
                "tasks": "输入已筛选任务的数量",
                "users": "输入过滤后的用户数量"
            },
            "id_list": {
                "companies": "输入所选公司数量",
                "devices": "输入所选设备数量",
                "files": "输入所选文件的数量",
                "groups": "输入所选设备组的数量",
                "productCodes": "输入所选产品代码的数量",
                "tasks": "输入所选任务的数量",
                "users": "输入所选用户数量"
            },
            "merge companies confirmation": "您即将合并{{sourceCompany}}与{{targetCompany}}两家公司。",
            "move companies confirmation": "您即将将{{sourceCompany}}迁移至{{targetCompany}}公司。",
            "move devices confirmation": "您确定要将指定数量的设备转移至另一家公司吗？",
            "number of lines": "行数",
            "selected 20 or more devices": "您已选中20台或更多设备...",
            "transfer devices confirmation": "您确定要将指定数量的设备转移至另一家公司吗？"
        },
        "confirm cannot revert": "此操作不可逆。",
        "confirm merge companies": "您确定要合并这些公司吗？",
        "count": "计数",
        "create company": "创建公司",
        "create company description": "在选定的母公司下创建新公司。",
        "create desktop license": "创建desktop许可证",
        "create desktop license description": "为客户公司签发新的在线FOTA Desktop许可证，包含其IP地址、硬件密钥及有效期（最长2年）。",
        "create group": "创建群组",
        "create group description": "将设备分组管理，实现简化操作与批量分配。",
        "create model": "创建模型",
        "create model description": "创建新设备模型时需指定名称、平台及TCT web支持功能。",
        "create offline license": "创建离线许可证",
        "create or edit group description": "固件与配置可批量分配至设备组。完成分配后，系统将为组内所有成员设备自动生成固件及/或配置更新任务。",
        "create role": "创建角色",
        "create role description": "通过命名、添加描述、选择所属公司及分配具体权限来创建新角色。",
        "create smart group": "创建智能组",
        "create smart group banner message": "",
        "create smart group description": "固件和配置文件可按平台分配至相应组别。文件分配完成后，系统将为该组所有设备自动生成更新任务。",
        "create task description first step": "创建多种任务类型，涵盖配置或固件更新、接收日志、配置等操作，可针对特定设备或筛选设备执行。此外，您还可为创建的任务设置计划任务，提升操作便利性。",
        "create task description last step": "创建任务前请确保以下信息准确无误。",
        "current level": "当前级别",
        "custom resource limits": {
            "at least one limit must be higher": "至少有一项限制值需高于默认高级版设置值。",
            "configuration files per device": "设备配置文件",
            "confirmation modal description": "您确定要更改公司\"{{companyName}}\"的以下资源配额限制吗？",
            "confirmation modal title": "更改公司资源限制？",
            "count": {
                "companies count": "企业数量：{{number}}",
                "configuration files per device count": "每台设备对应的配置文件数量：{{number}}",
                "tasks per group count": "每组任务数量：{{number}}",
                "users count": "用户数量：{{number}}"
            },
            "explanations": {
                "companies": "公司层级结构中可创建的子公司的总数。",
                "configuration files per device": "可存储的配置文件数量，1台设备对应1个配置文件。每个公司层级的最低保证配置文件数量为100个。",
                "tasks per group": "单个任务组中可包含的任务数量。",
                "users": "公司层级中可创建的用户总数。"
            },
            "main modal description": "为不同资源类型（如企业、用户、任务组任务或配置文件）设置自定义资源配额。自定义资源将持续有效直至高级版到期或手动重置。",
            "resources limit type": "资源限制类型",
            "revert custom resource limits": "恢复自定义资源限制",
            "revert custom resource limits description": "重置所有限制将恢复默认资源值，并将公司层级升级为高级版。",
            "revert custom resource limits description confirmation": "此操作将把资源限制恢复为\"高级\"级别的自动分配值。您确定要继续吗？",
            "revert custom resource limits title": "该公司的资源限制是手动设置的。",
            "revert custom resource limits title confirmation": "恢复自定义资源限制？",
            "tasks per group": "按组分配任务"
        },
        "date range": "日期范围",
        "date to": "用于",
        "delete companies": "删除公司",
        "delete deviceModels": "删除模型",
        "delete files": "删除文件",
        "delete file warning": "删除文件将同时取消相关任务及任务组。",
        "delete groups": "删除设备组",
        "delete productCodes": "删除产品代码",
        "delete roles": "删除角色",
        "delete tasks and history": "",
        "delete users": "删除用户",
        "description": "描述",
        "desktop license delete description": "您确定要删除桌面许可证\"{{name}}\"吗？",
        "desktop license name": "Desktop许可证名称",
        "device identifier": "设备标识符",
        "device transfer": {
            "main": {
                "description": "通过接收方公司生成的令牌，将选定或筛选的设备转移至无关联公司。",
                "title": "设备转移"
            },
            "receive devices": {
                "copy token": "将生成的令牌复制并发送给负责将设备从其公司转移至贵公司的相关人员。",
                "description": "生成接收设备令牌并发送至传输公司。",
                "token info": "该令牌为一次性使用，21天后失效。"
            },
            "transfer devices": {
                "confirmation": "您确定要将设备转移至以下公司吗？",
                "device token": "设备转移令牌必须从您希望转移设备的目标公司管理员处获取。",
                "transfer from file": "上传包含设备列表（IMEI）的文件，将您公司中的设备转移至您刚刚输入令牌的公司。"
            }
        },
        "device transfer token": "设备转移令牌",
        "downgrading company level is not possible": "公司层级的降级操作不可行",
        "download sample file message": "下载<1>CSV模板示例</1>以查看所需格式的范例。",
        "edit group banner message": "修改固件和/或配置文件将取消所有之前同类型的待处理任务。",
        "edit group description": "修改此设备组的设置。",
        "edit role description": "自定义角色的名称、描述及权限。已分配的公司无法更改。",
        "edit smart group description": "固件和配置文件可为各平台的设备组进行分配或变更。文件分配或变更后，系统将为该组所有设备自动生成更新任务。",
        "email": "电子邮件",
        "enter": "输入",
        "enter code": "输入代码",
        "enter description": "输入描述",
        "enter name": "输入名称",
        "example": "例如：",
        "expires at": "到期于",
        "explanation": "说明",
        "export device data": "导出设备数据",
        "export device description": "",
        "export file format": "导出文件格式",
        "feature": "功能",
        "feature control": "功能控制",
        "field disabled until company selected": "在选择公司前，此字段处于禁用状态。",
        "firmware": "固件",
        "files to download": "待下载文件",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "上传的1-Wire授权列表将自动排序，以提升功能的运行速度与准确性。",
                "bluetooth_authorization_list": "上传的蓝牙授权列表将自动排序，以提升功能的运行速度与准确性。"
            },
            "endings": {
                "file": "文件",
                "files": "文件"
            },
            "fail": {
                "multiple": "{{failCount}} 个 {{fileEnding}} 文件因错误未能上传，总计 {{totalCount}} 个文件。",
                "single": "{{failCount}} 个 {{fileEnding}} 文件因错误未能上传，总计 {{totalCount}} 个文件。"
            },
            "success": {
                "multiple": "所有文件已成功添加至所选公司。",
                "single": "所有文件已成功添加至所选公司。"
            }
        },
        "filtered": "过滤",
        "filtered companies": "筛选后的公司",
        "filtered devices": "已筛选设备",
        "filtered files": "过滤文件",
        "filtered groups": "筛选后的组",
        "filtered tasks": "筛选任务",
        "filtered users": "受限用户",
        "find tool": {
            "device": {
                "error not valid": "IMEI必须由15个字符组成",
                "error subtitle": "未找到设备。请尝试输入其他IMEI号。",
                "error title": "未检测到设备",
                "link": "前往设备",
                "no permission": "您无权查看此设备。"
            },
            "user": {
                "error not valid": "无效的电子邮件格式",
                "error subtitle": "未找到用户。请尝试输入其他用户邮箱。",
                "error title": "未找到用户",
                "link": "前往用户",
                "no permission": "您无权查看此用户。"
            }
        },
        "firmware date": "固件日期",
        "from form": "来自表单",
        "from file": "从文件",
        "general": "通用",
        "gsm_number": "GSM号码",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI限制",
        "import device data": "导入设备数据",
        "import device data description": "为所提供列表中的设备导入选定属性数据。",
        "import device data info": "每个属性均设有最大字符限制（括号内显示）。若属性内容超过限制，系统将自动截断至最大限制长度。",
        "import device data limit": "（最多{{limit}}个字符）",
        "imsi": "IMSI",
        "input text too long": "文本过长。允许的最大长度为{{maxLength}}个字符。",
        "invalid hardware key": "无效的硬件密钥格式",
        "invalid imei": "IMEI无效",
        "invalid ipv4": "无效的IPv4格式",
        "invalid serial": "无效序列号",
        "invalid value": "无效值",
        "inverted selection": "反向选择",
        "invite user": "邀请用户",
        "invite user description": "向选定母公司邀请新用户并设置其角色。发送后，用户需在30天内接受邀请，逾期邀请失效。",
        "invite user max roles": "最多允许设置5个角色。取消选择其中一个即可继续。",
        "log files": "日志文件",
        "make": "创建",
        "manage permissions": "管理所有账户及站点级数据。",
        "maximum value is": "最大值为{{value}}",
        "merge companies": "合并公司",
        "merge companies info": "所有源公司资源（设备、组、文件、公司、用户及其角色）将迁移至目标公司。建议在合并前审核用户角色。源公司将在迁移完成后被删除。",
        "merge companies disabled option": {
            "client to internal": "客户类型公司无法合并为内部类型公司。",
            "internal": "内部类型公司无法合并。",
            "lz code": "带代码的公司无法合并。"
        },
        "minimum value is": "最小值为{{value}}",
        "move companies disabled option": {
            "internal": "内部类型公司不可移动。"
        },
        "move device": "移动设备",
        "move device description": "将选定或筛选的设备移至公司层级结构中的现有公司及/或公司组。",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "移动设备",
        "name": "名称",
        "newest": "最新版本",
        "no dropdown files": {
            "description": "要选择此选项，请上传新的$t(Dialog##no dropdown files##file names##{{fileName}})文件。",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "1-Wire授权列表",
                "adas_firmware": "ADAS固件",
                "ble_fw": "BLE固件",
                "blue_nrg": "BlueNrg固件",
                "bluetooth_authorization_list": "蓝牙授权列表",
                "can_chip_firmware": "FM CAN芯片固件",
                "carrier_advance_firmware": "Carrier Advance 固件",
                "carrier_advance_settings": "Carrier Advance设置",
                "carrier_apx_firmware": "Carrier APX 固件",
                "carrier_apx_settings": "Carrier APX 设置",
                "certificate": "TLS证书",
                "configuration": "配置",
                "dsm_firmware": "DSM固件",
                "dtb": "DTB",
                "firmware": "固件",
                "fw_bundle": "固件包",
                "gnssm_download_assistant": "GNSS-M下载助手",
                "gnssm_firmware": "GNSS-M固件",
                "main configuration": "",
                "manual_geofence_list": "手动地理围栏场景列表",
                "meig_modem_firmware": "MeiG 通信模块固件",
                "netprisma_modem_firmware": "NETPRISMA通信模块固件",
                "psub": "订阅服务",
                "quectel_modem_firmware": "Quectel通信模块固件",
                "simcom_modem_firmware": ""
            },
            "main": "没有名为$t(Dialog##no dropdown files##file names##{{fileName}})的文件。"
        },
        "none": "无",
        "obd oem": "OBD原厂设备",
        "offline license delete description": "您确定要删除离线许可证\"{{name}}\"吗？",
        "oldest": "按时间排序",
        "only integers": "仅整数有效",
        "only numbers": "仅数字有效",
        "optional": "可选",
        "other companies": "其他公司",
        "parent company": "母公司",
        "permission preset": "权限预设",
        "platform compatibility": {
            "banner text": "部分选定设备型号与所选任务类型不兼容。对于不兼容的设备型号，该任务类型将不会被默认创建。",
            "compatible model devices": "兼容型号设备",
            "count text": "将为 {{totalCount}} 台设备中的 <1>{{compatibleCount}}</1> 台创建任务。",
            "create tasks for incompatible devices": "为不兼容设备创建任务。",
            "devices from file": "来自文件的设备",
            "platform": "{{title}}平台",
            "task applies": "任务适用范围",
            "task cannot be created": "不兼容型号的设备无法创建任务。"
        },
        "receiving company": "该公司将接收您的设备",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "此操作最多需要几分钟才能完成。",
            "banner description": "若需查看任务的最新状态，请查阅任务组详情或刷新页面。",
            "description": "点击\"接受\"将重试所有失败任务。您确定要继续吗？",
            "title": "是否重试组内所有任务？"
        },
        "revision": "修订版",
        "revision value error": "数值必须为两位数（00-99）。",
        "role name": "角色名称",
        "root company": "母公司",
        "sales email": "销售经理邮箱",
        "scheduled time warning": "定时任务不会更改设备的FOTA连接时间配置。若设备在选定时间段内连接FOTA WEB，任务将自动执行。请确保设备配置的FOTA WEB连接周期不短于选定时间窗口。",
        "schedule task": "计划任务",
        "select": "选择",
        "select at least one": {
            "companies": "请至少选择一家公司",
            "devices": "请至少选择一个设备",
            "files": "请至少选择一个文件",
            "groups": "请至少选择一个组",
            "tasks": "请至少选择一项任务",
            "users": "请至少选择一名用户"
        },
        "selected": "已选择",
        "selected companies": "已选择的公司",
        "selected deviceModels": "已选择的型号",
        "selected devices": "已选设备",
        "selected files": "选定文件",
        "selected groups": "已选择的设备组",
        "selected productCodes": "已选择的产品代码",
        "selected roles": "已选择的角色",
        "selected tasks": "已选择的任务",
        "selected users": "已选择的用户",
        "select company": "",
        "select group": "",
        "select time interval": "选择时间间隔",
        "selected time window": "已选择的时间窗口：{{fromDate}} 至 {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "为{{platformName}}平台设备选择可用文件。",
            "title": "{{platformName}}平台文件"
        },
        "sn": "序列号",
        "specific": "具体",
        "time period": "时间段",
        "time period custom": "自定义",
        "tls certificate transfer info": "",
        "token has expired": "令牌已过期",
        "token is valid": "令牌有效",
        "transfer companies": "转移公司",
        "transfer companies description": "选择将两家公司进行合并或迁移。部分操作不可逆。",
        "transfer devices": "转移设备",
        "tri source": {
            "selected tab description": {
                "create task": "选定任务将通过复选框为所选设备创建。",
                "general": "所选设备将使用复选框执行所选操作。"
            },
            "filtered tab description": {
                "create task": "选定任务将通过一个或多个可用筛选器，为符合条件的设备创建。",
                "general": "选定操作将针对符合一个或多个可用筛选条件的设备执行。"
            },
            "from file tab description": {
                "create task": "所选任务将针对上传文件中指定的设备创建。",
                "general": "所选操作将针对上传文件中指定的设备执行。"
            }
        },
        "unlocker": {
            "generate unlock key": "生成解锁密钥",
            "generate unlock key description": "请在下方字段输入TCT提供的设备\"锁定代码\"。点击\"生成\"按钮获取解锁密钥，随后在TCT中使用该密钥解锁设备。",
            "invalid lock code": "无效的设备锁定代码。",
            "limit reached": "您已达到生成的解锁密钥最大数量。",
            "lock code": "锁定代码",
            "unlock key": "解锁密钥",
            "unlock key success message": "解锁密钥生成成功。"
        },
        "upload file": "上传文件",
        "upload file description": "通过拖放区域或选择文件，可一次上传最多{{count}}个文件。",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "固件版本04.00.00及以上包含降级保护功能。有关固件变更的详细信息，请查阅我们的文档<1>Teltonika GPS Wiki</1>。点击\"下一步\"按钮即表示您已阅读并理解上述信息。",
        "upload firmware unsupported info": "此版本暂不提供更新服务，请联系Teltonika技术支持或您的Teltonika销售经理。",
        "use at least one filter": "请至少使用一个筛选条件",
        "user": "用户",
        "valid until": "有效期至",
        "valid until date disable description": "此字段仅在时间段设置为\"自定义\"时可修改",
        "vehicle model": "型号"
    },
    "Dropzone": {
        "add file": "添加文件",
        "add files": "添加文件",
        "drop file to upload": "拖放文件即可上传",
        "drop files to upload": "拖放文件即可上传",
        "error uploading the file": "上传文件时发生错误",
        "file invalid type": "所选文件类型无效。",
        "file successfully uploaded": "文件上传成功",
        "file syntax": "文件语法如下：",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "已达到最大文件限制。",
        "only one file can be attached": "每次仅可附加一个文件。",
        "or drop file to upload": "或拖放文件进行上传",
        "or drop files to upload": "或拖放文件进行上传",
        "rows detected": "文件中的行已成功检测到",
        "select file": "选择文件",
        "select files": "选择文件",
        "select file type": "请先选择文件类型。",
        "supported formats": "支持的格式",
        "too long file name": "文件名过长。最大允许长度为{{maxLength}}个字符。",
        "too many files description": "选定文件上传完成后，其余文件即可进行上传。",
        "too many files title": "单次最多可附加{{maxFiles}}个文件。"
    },
    "Error": {
        "error": "错误",
        "message wait": "请请耐心等待，直到我们修复该错误。",
        "title": "出错了！"
    },
    "Feature highlight": {
        "got it": "明白了",
        "new feature": "新功能！",
        "scenarios description": "现在，您可在设备上设置以下任一场景：超速检测、碰撞检测或拖拽检测。"
    },
    "Filter": {
        "access group": "",
        "activity_status": "状态",
        "all permissions": "所有权限",
        "batch_id": "批次ID",
        "company_id": "公司",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "创建者：",
        "current_configuration": "配置",
        "current_firmware": "固件",
        "device_imei": "设备 IMEI",
        "file type": "文件类型",
        "filtered by": "按以下条件筛选：",
        "filters used": "使用的过滤器",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "组",
        "id": "ID",
        "Invalid company": "无效公司",
        "model": "型号",
        "model_platform": "平台",
        "Multiple companies": "多家公司",
        "parent company": "母公司",
        "permission": "权限",
        "permission status": "状态",
        "role": "角色",
        "spec_id": "规格 ID",
        "status_id": "状态",
        "supported_task_type": "任务类型",
        "table filters": "表格筛选器",
        "task type": "任务类型",
        "task_queue": "队列",
        "type": "类型",
        "user status": "状态"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "ADAS固件文件大小不能为零。",
        "ADAS firmware is invalid.": "ADAS固件无效。",
        "All notifications were deleted.": "所有通知均已被删除。",
        "All notifications were marked as read.": "所有通知均已标记为已读。",
        "At least one user role must be provided.": "必须至少提供一个用户角色。",
        "Attributes length is invalid": "属性长度无效。",
        "Banner was updated.": "",
        "Batch was discarded": "批次已被丢弃。",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "批量属性更新任务已创建。设备属性即将更新。",
        "Bulk create job was created. Devices will be created shortly.": "批量创建任务已生成，设备将很快创建完毕。",
        "Bulk create job was created. Tasks will be created shortly.": "批量创建任务已生成，相关子任务即将创建。",
        "Bulk delete job was created. Companies will be removed shortly.": "批量删除任务已创建。相关公司账户即将被移除。",
        "Bulk delete job was created. Devices will be removed shortly.": "批量删除任务已创建。设备即将被移除。",
        "Bulk delete job was created. Files will be removed shortly.": "批量删除任务已创建。文件即将被移除。",
        "Bulk delete job was created. Groups will be removed shortly.": "批量删除任务已创建。相关组将很快被移除。",
        "Bulk delete job was created. Product codes will be removed shortly.": "批量删除任务已创建。产品代码即将被移除。",
        "Bulk delete job was created. Users will be removed shortly.": "批量删除任务已创建。用户账户即将被移除。",
        "Bulk task create job was created. Tasks will be created shortly.": "批量任务已创建，任务将很快显示。您可在\"任务组\"页面下的任务组详情中查看这些任务。",
        "Bulk update job was created. Devices will be updated shortly.": "批量更新任务已创建。设备即将开始更新。",
        "Bulk update job was created. Tasks will be updated shortly.": "批量更新任务已创建。任务即将更新。",
        "Can adapter was added.": "CAN适配器已添加。",
        "Can adapter was deleted.": "CAN适配器已被删除。",
        "Can adapter was updated.": "CAN适配器已更新。",
        "Can chip firmware file size can't be zero": "CAN芯片固件文件大小不能为零。",
        "Can chip firmware is invalid.": "CAN 芯片固件可能无效。",
        "Cannot delete company. Company is not empty.": "无法删除公司。公司不为空。",
        "Cannot delete file. It is used by pending or running tasks.": "无法删除该文件。该文件用于处理待处理或正在运行的任务。",
        "Cannot delete file. It is used by running tasks.": "无法删除文件。该文件正被运行中的任务使用。",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "无法删除分配给设备的產品代码。",
        "check your email for details": "",
        "Companies count limit exceeded.": "公司用户数量已超限。",
        "Companies in the request must belong to the selected root.": "请求中的公司必须属于所选根目录。",
        "Company merge job was created. It will be merged shortly.": "公司合并任务已创建，即将执行合并操作。",
        "Company name already exist.": "公司名称已存在。",
        "Company level change is not allowed.": "不允许进行公司层级的变更。",
        "Company level successfully changed": "公司层级变更已成功完成。",
        "company level successfully reverted": "公司层级已成功恢复至自动分配层级。",
        "Company not allowed to be merged": "公司不得合并。",
        "company resource limits changed": "公司资源限制已成功变更。",
        "Company was created.": "公司已成立。",
        "Company was deleted.": "公司已被删除。",
        "Company was updated.": "公司信息已更新。",
        "compatibilities added": "{{count}}项新兼容性在同步过程中被添加。",
        "compatibilities synchronized": "已成功同步缺失的兼容性。",
        "Configuration cannot have FOTA functionality disabled": "配置中不得禁用FOTA功能。",
        "Configuration file cannot contain duplicate parameters": "配置文件中不得包含重复参数。",
        "Configuration file size can't be zero": "配置文件大小不能为零。",
        "Configuration files count limit exceeded.": "配置文件数量超出限制。",
        "Configuration version must be defined": "必须定义配置版本。",
        "custom resource limits successfully reverted": "自定义资源限制已成功恢复为系统自动分配的默认限制。",
        "Custom roles feature is not enabled.": "自定义角色功能仅限高级公司级用户使用。此前创建的自定义角色可被删除。",
        "desktop license added": "桌面许可证\"{{name}}\"已成功添加。",
        "Devices already are in target company": "设备已经在目标公司中。",
        "Device already exists.": "设备已存在。",
        "Device bulk attribute update file cannot be empty": "设备批量属性更新文件不可为空。",
        "Device bulk attribute update file should be .csv": "设备批量属性更新文件应为.csv格式。",
        "Device export limit reached. You can not export more than 100000 devices": "设备导出上限已达。您无法导出超过100,000台设备。",
        "Device import limit reached. You can not import more than 100 devices": "设备导入上限已达。您无法导入超过100台设备。",
        "Device model and task type compatibility was updated.": "已更新设备型号与任务类型的兼容性。",
        "Device model was created.": "设备模型已创建。",
        "Device model was deleted.": "设备型号已被删除。",
        "Device model was updated.": "设备型号已更新。",
        "Device not found": "未找到设备。",
        "Device Transfer job was created. Devices will be transfered shortly.": "设备迁移任务已创建。设备即将开始迁移。",
        "Device was added.": "设备已添加。",
        "Device was deleted.": "设备已被删除。",
        "Device was updated.": "设备已更新。",
        "Email or password is incorrect.": "您输入的电子邮箱或密码有误。",
        "Failed to create Product code": "创建产品代码失败。",
        "Failed to delete Product code": "删除产品代码失败。",
        "Failed to import devices.": "设备导入失败。",
        "Failed to Read Product code": "读取产品代码失败。",
        "Failed to retry failed tasks": "重试失败的任务失败。",
        "Failed to update Product code": "产品代码更新失败。",
        "Failed to update task for retry": "重试失败任务失败。",
        "Field is not valid": "字段无效。",
        "File description is too long. Max 255 characters allowed.": "文件描述过长。允许的最大字符数为255个。",
        "File exceeds entries limit of 10000.": "该文件超过了10,000条的条目限制。",
        "File must not contain duplicated IMEIs": "文件中不得包含重复的IMEI号。",
        "File must not contain IMEIs that already exist in database.": "文件中不得包含数据库中已存在的IMEI号。",
        "File must not contain invalid IMEIs": "文件中不得包含无效的IMEI号。",
        "File name is too long. Max 255 characters allowed.": "文件名过长。允许的最大长度为255个字符。",
        "File name should not contain illegal characters or symbols": "文件名中不得包含任何特殊字符。",
        "File not found": "文件未找到。",
        "File was deleted.": "文件已被删除。",
        "File was successfully uploaded.": "文件已成功上传。",
        "File was updated.": "文件已更新。",
        "File was uploaded. Devices will be imported shortly.": "文件已上传。设备即将导入。",
        "File will be created shortly. Check files in a second.": "文件即将创建完毕。请稍后查看文件。",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "固件文件大小不能为零。",
        "First device in file not found.": "文件中的第一台设备未找到。",
        "Forbidden": "禁止访问。",
        "Group name already exist.": "组名已存在。",
        "Group was added.": "\"'{{group}}'\"已成功创建。",
        "Group was created.": "已创建组。",
        "Group was deleted.": "群组已被删除。",
        "Group was updated.": "组已更新。",
        "Invalid device bulk update attribute": "无效设备批量更新属性。",
        "Invalid email address.": "无效的电子邮件地址。",
        "Invalid file contents": "文件内容无效。",
        "Invalid file name": "无效的文件名。",
        "Invalid invitation token.": "无效的邀请令牌。",
        "Invalid token": "令牌无效。",
        "Invalid token length": "令牌长度无效。",
        "Internal Server Error": "内部服务器错误。",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "许可证已被删除。",
        "License was updated.": "许可证已更新。",
        "Maximum companies hierarchy depth exceeded": "超出了公司层级的最大深度",
        "Maximum device group size exceeded.": "超出了设备组的最大大小。",
        "Method Not Allowed": "方法不被允许。",
        "Network Error": "网络错误。",
        "No changes made": "未作任何修改。",
        "No resources found.": "未找到相关资源。",
        "not allowed to affect batch": {
            "description": "请确保您控制的是创建此任务组的用户的公司。",
            "title": {
                "approve": "您无权批准此批次。",
                "discard": "您无权限丢弃此批次。"
            }
        },
        "Not Found": "未找到。",
        "Notification was deleted.": "通知已被删除。",
        "notify when done title": "此操作可能需要一段时间。点击下方按钮关闭此界面，完成后您将收到通知。",
        "Obd record was created.": "OBD记录已创建。",
        "Obd record was updated.": "OBD记录已更新。",
        "offline license added": "离线许可证\"{{name}}\"已成功添加。",
        "Offline license was deleted.": "离线许可证已被删除。",
        "Only id_list source is supported.": "仅支持id_list数据源。",
        "Only users with Teltonika email can be invited into internal companies.": "仅具有 Teltonika 邮件的用户可以被邀请到内部公司。",
        "Only users with Teltonika email can be moved into internal companies.": "仅持有Teltonika邮箱的用户可被移入内部公司。",
        "Parent company cannot be a descendant of the updated company.": "母公司不能是更新公司之下的子公司。",
        "Password reset link was sent to Your email.": "密码重置链接已发送至您的邮箱。",
        "Password reset token is invalid, expired or related user no longer exists.": "密码重置令牌无效、已过期或用户已不存在。",
        "Password was changed.": "密码已更改。",
        "product code added": "产品代码\"{{code}}\"已成功添加。",
        "Product code is too long. Max 200 characters allowed.": "产品代码过长。允许的最大长度为200个字符。",
        "ProductCode already exists.": "产品代码已存在。",
        "ProductCode not found": "未找到产品代码。",
        "Product code was deleted.": "产品代码已被删除。",
        "Product code was updated.": "产品代码已更新。",
        "Retry failed tasks job was created": "已创建重试失败任务的作业。",
        "Role cannot be set for an internal user.": "内部用户无法设置角色。",
        "Role was created.": "角色已创建。",
        "Role was deleted.": "角色已被删除。",
        "Role was updated.": "角色已更新。",
        "selected company changed": "所选公司已变更。",
        "Selected firmware bundle is not supported by the device.": "所选固件包不被该设备支持。",
        "Server Error": "服务器错误。",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "短信已发送。",
        "Something went wrong while saving a new password.": "保存新密码时出现错误。",
        "Successfully logged out.": "成功登出。",
        "System Admin user level is required in order to perform this action.": "执行此操作需具备系统管理员用户权限。",
        "Target company cannot be a descendant of source company.": "目标公司不能是源公司的子公司。",
        "Task create limit exceeded.": "您无法为超过100,000台设备创建任务组。",
        "Task type is not retriable": "任务类型不可重试",
        "Task was added.": "任务已添加。",
        "task was created": "该任务已为{{imei}}创建（类型为{{taskType}}）。您可在设备详情页的\"设备\"选项卡下\"任务\"栏目中查看此任务。",
        "Task was updated.": "任务已更新。",
        "Tasks were approved": "任务已获批准。",
        "The given data was invalid.": "所提供的数据无效。",
        "time zone changed": "时区已更改。",
        "Token cannot be null or empty": "令牌不能为空或无效。",
        "token created": "API令牌已成功创建。",
        "Token has expired": "令牌已过期。",
        "Token's and token's owner companies do not match": "令牌与令牌所属公司不匹配。",
        "Token was deleted.": "令牌已被删除。",
        "Too many resources in the request": "请求中的资源过多",
        "Too Many Requests": "请求过多。",
        "Transfer token created": "转移令牌已创建。",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "用户已启用双因素认证。",
        "Two factor authentication successfully disabled.": "双因素认证已成功禁用。",
        "Unable to send SMS. This device does not have a GSM number assigned.": "无法发送短信。该设备未分配GSM号码。",
        "Unable to validate Your request.": "无法验证您的请求。",
        "Unauthenticated.": "未经过身份验证。",
        "Unauthorized": "未经授权。",
        "User access level is not valid": "用户访问级别无效",
        "User invitation was revoked": "邀请已成功取消。",
        "User invitation was re-sent": "用户邀请已重新发送。",
        "User is already in the system.": "用户已登录系统。",
        "User was created.": "用户已创建。",
        "User was deleted.": "用户已被删除。",
        "User was invited.": "用户邀请已成功发送。",
        "User was updated": "用户信息已更新。",
        "Users count limit exceeded.": "用户数量已超出限制。",
        "Your password has been changed.": "您的密码已更改。"
    },
    "General": {
        "0": "用户",
        "5": "支持",
        "10": "管理员",
        "15": "管理员管理器",
        "19": "",
        "20": "系统用户",
        "99": "超级用户",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "公司创建",
        "Company.Delete": "公司删除",
        "Company.Merge": "公司合并",
        "Company.Update": "公司动态",
        "Device.Export": "设备导出",
        "Device.Read": "设备读取",
        "Device.SecretsRead": "",
        "Device.Transfer": "设备转移",
        "Device.Unlock": "设备解锁",
        "Device.Update": "设备更新",
        "DeviceGroup.Create": "设备组创建",
        "DeviceGroup.Delete": "设备组删除",
        "DeviceGroup.Read": "设备组读取",
        "DeviceGroup.Update": "设备组更新",
        "File.Create": "文件创建",
        "File.Delete": "文件删除",
        "File.Download": "文件下载",
        "File.Read": "文件读取",
        "File.TctWebAccess": "TCT web",
        "File.Update": "文件更新",
        "Role.Create": "角色创建",
        "Role.Delete": "角色删除",
        "Role.Read": "角色读取",
        "Role.Update": "角色更新",
        "Task.Create": "任务创建",
        "Task.Read": "任务读取",
        "Task.Retry": "任务重试",
        "Task.Update": "任务更新",
        "TaskGroup.Read": "任务组读取",
        "TctIntegration.Access": "TCT集成",
        "Token.Create": "令牌创建",
        "Token.Delete": "令牌删除",
        "Token.Read": "令牌读取",
        "User.Create": "",
        "User.Delete": "用户删除",
        "User.Read": "用户读取",
        "User.Update": "用户更新",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "1-Wire授权列表",
        "1_wire_authorization_list": "1-Wire授权列表",
        "Active": "活跃",
        "adas_firmware": "ADAS固件",
        "apx_firmware": "APX固件",
        "assign can package": "分配CAN数据包",
        "assigned package": "指定套餐",
        "automatic": "自动",
        "banner management": "",
        "batches": "任务组",
        "black_box": "黑匣子",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE固件",
        "blue_nrg": "BlueNRG固件",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "蓝牙授权列表",
        "bluetooth_authorization_list": "蓝牙授权列表",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "不兼容",
                "true": "兼容"
            },
            "web_editor_support": {
                "false": "TCT web不支持",
                "true": "支持TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN适配器名称",
        "can bootstring": "Bootstring",
        "can configuration": "OEM配置",
        "can_debug_log": "CAN总线调试日志",
        "can oem file package": "OEM文件包",
        "can oem file vehicle": "OEM文件载体",
        "can package": "OEM 配套",
        "can program number": "CAN程序编号",
        "can revision": "CAN修订版",
        "can software date": "CAN软件数据",
        "can type": "CAN总线类型",
        "Cancelled": "已取消",
        "cancel task": "取消任务",
        "can_chip_firmware": "FM CAN芯片固件",
        "carrier_advance_firmware": "Carrier Advance 固件",
        "carrier_advance_settings": "Carrier Advance设置",
        "carrier_apx_firmware": "Carrier APX 固件",
        "carrier_apx_settings": "Carrier APX 设置",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier温度记录仪文件",
        "certificate": "证书",
        "click for more details": "点击查看更多详情",
        "client ip": "客户端IP",
        "clone model": "克隆设备模型",
        "collapse menu": "折叠菜单",
        "companies": "企业",
        "company": "公司",
        "company level": "公司级",
        "company type": "公司类型",
        "company name": "公司名称",
        "Completed": "已完成",
        "Completed with errors": "已完成但存在错误",
        "configuration": "配置",
        "configuration_36": "配置（FM36）",
        "configuration_64": "配置（FMB64）",
        "crash_dump": "崩溃转储日志",
        "created at": "创建于",
        "created by": "创建者：",
        "custom": "自定义",
        "custom resource limits": "自定义资源配额",
        "dashboard": "仪表盘",
        "delete desktop license": "删除桌面许可证",
        "delete offline license": "删除离线许可证",
        "desktopLicenses": "桌面许可证",
        "device_export_file_csv": "设备导出文件（.csv格式）",
        "device_export_file_xlsx": "设备导出文件（.xlsx格式）",
        "deviceModels": "模型",
        "deviceModelTaskCompatibilities": "兼容性",
        "device_transfer_report": "设备转移报告",
        "device group": "组",
        "DeviceImportFile": "设备导入文件",
        "devices": "设备",
        "download file": "下载文件",
        "download offline license": "下载离线许可证",
        "dsm_firmware": "DSM固件",
        "dtb": "DTB",
        "edit compatibility": "编辑设备兼容性",
        "edit model": "编辑设备型号",
        "edit company": "编辑公司",
        "edit desktop license": "编辑桌面许可证",
        "edit device": "编辑设备",
        "edit file": "编辑文件",
        "edit group": "编辑组",
        "edit in tct web": "在TCT web中编辑",
        "edit in tct web disabled": "TCT web编辑功能仅面向企业级高级用户开放。",
        "edit product code": "编辑产品代码",
        "edit role": "编辑角色",
        "edit smart group": "编辑智能组",
        "edit user": "编辑用户",
        "Empty": "空",
        "enter here": "请在此处输入",
        "exception_info": "异常信息",
        "Executing": "执行",
        "expand menu": "展开菜单",
        "Expired": "已过期",
        "Factory": "",
        "Failed": "失败",
        "file": "文件",
        "file data": "文件数据",
        "files": "文件",
        "file deleted": "文件已被删除",
        "firmware": "固件",
        "firmware_36": "固件（FM36）",
        "firmware_64": "固件（FMB64）",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "固件包",
        "fw_bundle_ble": "捆绑包 - BLE固件",
        "fw_bundle_ble_dtb": "捆绑包 - BLE DTB",
        "fw_bundle_can": "捆绑包 - CAN固件",
        "fw_bundle_can_dtb": "捆绑包 - CAN DTB",
        "fw_bundle_dtb": "捆绑包 - 主DTB",
        "fw_bundle_mainfw": "捆绑包 - 主固件",
        "generic": "",
        "global_configuration": "全局配置",
        "global_firmware": "全球固件",
        "gnssm_download_assistant": "GNSS-M下载助手",
        "gnssm_firmware": "GNSS-M固件",
        "group": "组",
        "groups": "设备组",
        "hardware key": "硬件密钥",
        "id": "ID",
        "id_collection_file": "ID收集文件",
        "imei restriction": "IMEI限制",
        "Inactive": "非活动状态",
        "Invalid": "无效",
        "invalid model": "无效模型",
        "invalid model_name": "无效模型",
        "InvitationExpired": "已过期的邀请",
        "InvitationPending": "待邀请",
        "Legacy": "传统系统",
        "legacy model": "传统模型",
        "legacy model_platform": "传统平台",
        "legacy platform": "传统平台",
        "license has expired": "许可证已过期",
        "loading": "正在加载",
        "log": "日志",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "手动",
        "ManualGeofenceList": "",
        "manual geofence list": "手动地理围栏场景列表",
        "manual_geofence_list": "手动地理围栏场景列表",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Meig调制解调器固件",
        "menu": "菜单",
        "modem version": "调制解调器版本",
        "netprisma_modem_firmware": "NETPRISMA调制解调器固件",
        "nmea_log": "NMEA日志",
        "no": "无",
        "no results": "未找到初始结果",
        "no results description": "当{{name}}上传至FOTA WEB后，您即可在此查看相关数据",
        "not assigned": "未分配",
        "not assigned configuration_file_id": "配置未分配",
        "not assigned current_configuration": "配置未分配",
        "not assigned current_firmware": "固件未分配",
        "not assigned firmware_file_id": "固件未分配",
        "not assigned group_id": "未分配组",
        "not assigned model": "模型未分配",
        "not assigned spec_id": "Spec ID尚未分配",
        "not assigned task_type": "任务类型未分配",
        "obd_chip_firmware": "FM OBD芯片固件",
        "obd chip firmware version": "OBD芯片固件版本",
        "Offline": "离线",
        "offline licenses": "离线许可证",
        "Online": "在线",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "或",
        "other": "其他",
        "Pending": "待处理",
        "Pending approval": "等待审批",
        "permission disabled": "已禁用",
        "permission enabled": "已启用",
        "productCodes": "产品代码",
        "psub": "订阅文件",
        "quectel_fw": "Quectel调制解调器固件（quectel_fw）",
        "quectel_modem_firmware": "Quectel调制解调器固件",
        "resend invite": "重新发送邀请",
        "restricted": "受限",
        "retry": "重试",
        "roles": "角色与权限",
        "Running": "运行中",
        "RxAutoscan": "接收自动扫描CAN文件",
        "RxBlackBox": "接收黑匣子",
        "RxBluetoothAuthorizationList": "接收蓝牙授权列表",
        "RxCanDebugLog": "接收CAN调试日志",
        "RxCarrierExtractions": "下载 Carrier 提取",
        "RxCarrierLoggerFiles": "下载Carrier温度记录仪文件",
        "RxConfiguration": "接收配置",
        "RxCrashDump": "接收崩溃转储日志",
        "RxExceptionInfo": "接收异常信息",
        "RxLog": "接收内部日志",
        "RxManualGeofenceList": "接收手动地理围栏场景列表",
        "RxNmeaLog": "接收NMEA日志",
        "RxOneWireAuthorizationList": "接收1-Wire授权列表",
        "RxWdLog": "接收看门狗（WD）日志",
        "select company": "选择公司",
        "SetBindSim": "将设备与当前SIM卡绑定",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "禁用功能",
        "SetEnableFeature": "启用功能",
        "SetForceLockSim": "强制锁定SIM卡",
        "SetUnbindSim": "解除设备与SIM卡的绑定",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "状态",
        "task details": "任务详情",
        "task groups": "任务组",
        "tasks": "任务组",
        "tasksCompatibility": "任务兼容性",
        "task type": "任务类型",
        "Tct": "",
        "time zone": "时区",
        "total": "总计",
        "tutorials": "教程",
        "TxAdasFirmware": "上传ADAS固件",
        "TxAgpsMt3333": "传输AGPSM文件",
        "TxAgpsQuectelL89": "传输AGPSQ文件",
        "TxAutoscanCanConfiguration": "上传自动扫描OEM文件",
        "TxBleFirmware": "上传BLE固件",
        "TxBlueNrgFirmware": "上传BlueNrg固件",
        "TxBluetoothAuthorizationList": "上传蓝牙授权列表",
        "TxBundleBle": "上传BLE固件",
        "TxBundleBleDtb": "上传BLE DTB设备清单",
        "TxBundleCan": "上传CAN固件",
        "TxBundleCanDtb": "上传CAN DTB",
        "TxBundleDtb": "上传主DTB",
        "TxBundleFirmware": "上传主固件",
        "TxCanAdapterModeChange": "更改外部CAN适配器模式",
        "TxCanAdapterModeChangeInternal": "更改内部CAN适配器模式",
        "TxCanAdapterUpdate": "上传CAN适配器固件",
        "TxCanAdapterUpdateInternal": "更新内部CAN适配器",
        "TxCanChipFirmware": "上传FMXY50 CAN芯片固件",
        "TxCanConfiguration": "上传OEM文件",
        "TxCarrierAdvanceFirmware": "更新 Carrier Advance 固件",
        "TxCarrierAdvanceSettings": "更新 Carrier Advance 设置",
        "TxCarrierApxFirmware": "更新Carrier APX固件",
        "TxCarrierApxSettings": "更新Carrier APX设置",
        "TxConfiguration": "上传配置",
        "TxDsmFirmware": "上传DSM固件",
        "TxDtb": "上传DTB",
        "TxFirmware": "固件上传",
        "TxFirmwareBundle": "上传固件包容器",
        "TxFirmwareBundleParts": "上传固件包",
        "TxFotaCertificate": "更新FOTA证书",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "上传GNSS-M下载助手",
        "TxGNSSMFirmware": "上传GNSS-M固件",
        "TxManualGeofenceList": "手动上传地理围栏场景列表",
        "TxMeigModemDeltaFirmware": "上传MeiG Delta调制解调器固件",
        "TxNetprismaModemDeltaFirmware": "上传 NETPRISMA Delta 调制解调器固件",
        "TxObdChipFirmware": "更新OBD芯片",
        "TxObdConfig": "传输OBD配置文件",
        "TxOneWireAuthorizationList": "上传1-Wire授权列表",
        "TxPSub": "传输订阅文件",
        "TxQuectelModemDeltaFirmware": "上传Quectel Delta调制解调器固件",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "上传用户TLS证书",
        "users": "用户",
        "Unknown": "未知",
        "unknown": "未知",
        "unknown model_platform": "未知平台",
        "unknown origin": "",
        "unknown platform": "未知平台",
        "unrestricted": "无限制",
        "Verifying": "验证",
        "vin": "VIN",
        "vip status": "VIP状态",
        "wd_log": "WD日志",
        "yes": "是"
    },
    "Maintenance": {
        "title": "稍等！我们正在维护中。"
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} 因服务器错误失败。",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "您无权取消所有已选任务。部分任务关联了来自不同公司的资源。",
            "Cancel tasks action failed. No resources found.": "未找到符合您选择的任务。请检查任务选择并重新尝试。",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "公司\"{{SourceCompanyName}}\"（{{SourceCompanyId}}）已并入\"{{TargetCompanyName}}\"（{{TargetCompanyId}}）。",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "公司合并失败。由于设置或权限不兼容，公司\"{{SourceCompanyId}}\"与\"{{TargetCompanyId}}\"无法合并。",
            "Create device group tasks action failed. No resources found.": "无法为智能组创建任务。请尝试重新分配该文件。",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "为设备组ID：{{GroupId}}下的设备创建了{{CreatedTaskCount}}项任务。",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "您无权为所有选定设备创建任务。部分设备归属不同公司。",
            "Create tasks action failed. No resources found.": "未找到符合您选择的设备。请检查设备选择并重试。",
            "Create tasks action failed. No resources processed.": "处理所选设备失败。请尝试重新创建任务组。",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "您无权删除所有选定公司。部分公司不属于您的直接管理范围。",
            "Delete companies action failed. No resources found.": "未找到符合您筛选条件的公司。请检查公司选择并重新尝试。",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "您无权删除所有选定文件。部分文件关联着不同公司的资源。",
            "Delete files action failed. No resources found.": "未找到符合您选择的文件。请检查文件选择并重试。",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "您无权删除所有选中的设备组。部分设备组包含来自不同公司的资源。",
            "Delete groups action failed. No resources found.": "未找到符合您选择的设备组。请检查设备组选择并重新尝试。",
            "Delete product codes action failed. No resources found.": "未找到与您选择匹配的产品代码。请检查产品代码选择并重试。",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "您无权删除所有选定用户。部分用户隶属于不同公司。",
            "Delete users action failed. No resources found.": "未找到符合您筛选条件的用户。请检查用户筛选条件后重新尝试。",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}}台设备已导出至\"{{Filename}}\"。",
            "{{DevicesCount}} device(s) imported.": "已导入{{DevicesCount}}台设备。",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "已处理{{DevicesProcessedCount}}台设备，创建{{TasksCreatedCount}}项任务。",
            "Export devices action failed. No resources found.": "未找到符合您选择的设备。请检查设备选择并重试。",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "任务组 {{BatchId}} 中有 {{FailedTaskCount}} 个任务返回至待处理状态。",
            "Invalid request scope. Resources must belong to single root.": "请求作用域无效。资源必须属于单一根目录。",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "已删除{{ProcessedCount}}家公司。",
            "{{ProcessedCount}} device group(s) deleted.": "已删除{{ProcessedCount}}个设备组。",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} 个设备属性已更新。",
            "{{ProcessedCount}} device model(s) deleted.": "已删除{{ProcessedCount}}台设备型号。",
            "{{ProcessedCount}} device(s) updated.": "已更新{{ProcessedCount}}台设备。",
            "{{ProcessedCount}} file(s) deleted.": "已删除{{ProcessedCount}}个文件。",
            "{{ProcessedCount}} product code(s) deleted.": "已删除{{ProcessedCount}}个产品代码。",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} 个任务已取消。",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} 个任务已更新。",
            "{{ProcessedCount}} user(s) deleted.": "已删除{{ProcessedCount}}个用户。",
            "Retry tasks action failed. No resources found.": "未找到符合您选择的任务。请检查任务选择并重新尝试。",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "您无权转移所有选定设备。部分设备归属于不同公司。",
            "Transfer devices action failed. No resources found.": "未找到符合您选择的设备。请检查设备选择并重试。",
            "Transfer devices action failed. No resources processed.": "处理所选设备失败。请尝试重新传输设备。",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "已转移 {{TransferredDevicesCount}} 台设备，共计 {{TotalDevicesToTransfer}} 台设备。",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "您无权更新所有选定设备。部分设备归属于不同公司。",
            "Update devices action failed. No resources found.": "未找到符合您选择的设备。请检查设备选择并重试。",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "您无权限更新所有选定设备的属性。部分设备归属于不同公司。",
            "Update devices attributes action failed. No resources found.": "未找到符合您选择的设备。请检查设备选择并重试。",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "您无权限更新所有选定任务。部分任务关联了来自不同公司的资源。",
            "Update tasks action failed. No resources found.": "未找到符合您选择的任务。请检查任务选择并重新尝试。",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "无通知",
        "notifications": "通知",
        "notifications will be listed": "所有新通知都将在此处列出",
        "remove notification": "移除通知",
        "see previous notifications": "查看历史通知",
        "timestamps": {
            "days ago": "{{days}}天前",
            "hours ago": "{{hours}}小时前",
            "minutes ago": "{{minutes}} 分钟前",
            "moments ago": "就在几分钟前"
        },
        "title": {
            "BackgroundActionFailed": "操作失败",
            "CompaniesSuccessfullyDeleted": "企业成功删除",
            "CompanyBulkDeleteFailed": "删除公司时发生错误",
            "CompanyLevelChanged": "公司层级变更",
            "CompanyLevelDowngradeReminder": "即将实施的公司级降级操作",
            "CompanyMergeFailed": "合并公司时发生错误",
            "CompanySuccessfullyMerged": "企业成功合并",
            "DeviceAttributesSuccessfullyUpdated": "设备属性已成功更新",
            "DeviceBulkAttributeUpdateFailed": "更新设备属性时发生错误",
            "DeviceBulkUpdateFailed": "设备更新过程中发生错误",
            "DeviceExportFailed": "在导出设备时发生错误",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "设备组已成功删除",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "创建智能组任务时发生错误",
            "DeviceGroupTasksSuccessfullyCreated": "智能群组任务已成功创建",
            "DeviceModelBulkDeleteFailed": "删除设备型号时发生错误",
            "DeviceModelsSuccessfullyDeleted": "设备型号已成功删除",
            "DevicesSuccessfullyTransferred": "设备已成功转移",
            "DevicesSuccessfullyUpdated": "设备更新成功",
            "DeviceTransferFailed": "设备传输过程中发生错误",
            "ExportFailed": "资源导出失败",
            "ExportSucceeded": "设备导出成功",
            "FailedTasksRetryFailed": "在重试任务时发生错误",
            "FailedTasksSuccessfullyRetried": "任务重试成功",
            "FileBulkDeleteFailed": "删除文件时发生错误",
            "FilesSuccessfullyDeleted": "文件已成功删除",
            "GroupBulkDeleteFailed": "删除设备组时发生错误",
            "ImportFailed": "资源导入失败",
            "ImportSucceeded": "设备已成功导入",
            "ProductCodeBulkDeleteFailed": "删除产品代码时发生错误",
            "ProductCodesSuccessfullyDeleted": "产品代码已成功删除",
            "ResourceUpdateFailed": "资源更新失败",
            "ResourceUpdateSucceeded": "资源更新成功",
            "RoleBulkDeleteFailed": "删除角色时发生错误",
            "RolesSuccessfullyDeleted": "角色已成功删除",
            "TaskBulkCancelFailed": "在取消任务时发生错误",
            "TaskBulkCreateFailed": "创建任务组时发生错误",
            "TaskBulkUpdateFailed": "更新任务时发生错误",
            "TaskGroupSuccessfullyCreated": "任务组创建成功",
            "TasksPropagationFailed": "任务传播作业失败",
            "TasksPropagationSucceeded": "任务传播作业已成功完成",
            "TasksPropagationWarning": "任务传播作业已结束，伴随警告信息",
            "TasksSuccessfullyCanceled": "任务已成功取消",
            "TasksSuccessfullyUpdated": "任务已成功更新",
            "UserBulkDeleteFailed": "删除用户时发生错误",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "用户已成功删除"
        }
    },
    "Permission actions": {
        "Access": "TCT集成",
        "Create": "创建",
        "Delete": "删除",
        "Download": "下载",
        "Export": "导出",
        "Merge": "合并",
        "Read": "读取",
        "Retry": "重试",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "转移",
        "Unlock": "解锁",
        "Update": "更新"
    },
    "Permission groups": {
        "company": "企业",
        "device": "设备",
        "device group": "设备组",
        "file": "文件",
        "role": "角色",
        "task": "任务",
        "task group": "任务组",
        "token": "令牌",
        "user": "用户"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "此功能对基础级公司用户不可用。",
                "token list": "基础公司级别的用户禁用API集成令牌功能。"
            },
            "custom_role_support": {
                "create role": "此功能仅限拥有高级公司级别的用户使用。",
                "edit role": "此功能仅限企业高级版用户使用。此前创建的自定义角色可被删除。",
                "edit user": "此功能仅限拥有高级公司级别的用户使用。先前分配的自定义角色可被移除。"
            },
            "task_schedule_support": {
                "table head": "此功能仅限标准版和高级版企业用户使用。此前已添加的定时任务仍将正常执行。"
            }
        },
        "general message": "此功能仅限标准版和高级版企业级用户使用。",
        "resource_limit_settings": {
            "tasks_per_group": "您一次不能为超过 {{limitCount}} 台设备创建任务。"
        }
    },
    "Search": {
        "code": "代码",
        "description": "描述",
        "email": "电子邮件",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "模型",
        "name": "名称",
        "product code": "产品代码",
        "role name": "角色名称",
        "serial": "序列号",
        "search by": "按以下条件搜索：",
        "search company name": "搜索公司名称"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "您即将禁用双重验证功能。此操作可能导致您的FOTA WEB账户安全性降低。是否确定继续？",
                    "title": "确定吗？"
                },
                "send email code": {
                    "enter code": "出于安全考虑，请输入验证码以确认邮箱地址。"
                },
                "send otp code": {
                    "description": "系统已向您的验证应用发送六位数验证码。出于安全考虑，请在下方输入框中输入生成的验证码。",
                    "no access": {
                        "authenticator": "若您已无法访问与该账户关联的验证器应用，则需通过修改密码来停用双重验证功能。",
                        "email": "若您已无法访问该账户关联的邮箱，需先修改密码以停用多因素身份验证。"
                    }
                },
                "title": "禁用双因素认证"
            },
            "get email code": {
                "description": "请在下一屏幕使用该验证码确认您的账户。",
                "description modal": "使用该代码验证您的账户。",
                "title": "点击\"发送验证码\"后，系统将向<1>{{email}}</1>发送唯一验证码。"
            },
            "get secret code": {
                "description": "您需要使用身份验证器移动应用程序完成此流程，例如以下任一应用："
            },
            "select authentication type": {
                "authentication app description": "通过Microsoft Authenticator或Google Authenticator等应用获取唯一验证码。",
                "description": "为保障您的账户及客户数据安全，请通过以下任一方式设置双因素认证：",
                "description modal": "选择您偏好的身份验证方式。",
                "email": "电子邮件",
                "email description": "每次尝试登录时，我们都会向您的邮箱发送一次性验证码。",
                "recommended": "推荐",
                "title": "所有FOTA WEB用户必须启用双因素认证（2FA）。",
                "title modal": "选择认证方式"
            },
            "send email code": {
                "description": "请在下方字段输入验证码，点击\"验证\"继续。",
                "enter code": "请输入验证码以验证邮箱。",
                "title": "已向<1>{{email}}</1>发送唯一验证码。",
                "verification code": "验证码"
            },
            "send otp code": {
                "click to scan code": "点击此处扫描二维码",
                "click to type code": "点击此处手动输入代码",
                "incorrect code": "错误代码",
                "scan QR code": "扫描二维码进入应用",
                "six digit code": "由您的应用生成的六位数代码",
                "title": "您需要使用身份验证器移动应用完成此流程，例如：<1>Microsoft Authenticator</1> 或 <2>Google Authenticator</2>。",
                "type text code": "将文本代码输入您的应用程序"
            },
            "settings": {
                "description": "双因素认证是额外的安全层，通过您所知（密码）和您所持有（手机、安全密钥、电子邮件）的验证要素来确认您的身份。",
                "disabled": "已禁用",
                "enabled": "已启用",
                "title": "双因素认证"
            },
            "success message": {
                "alert": "双因素认证已成功启用。",
                "description": "每次您使用电子邮箱和密码登录时，系统都会要求您输入验证码。",
                "title": "您已成功启用双因素认证。",
                "title modal": "已启用双因素认证！"
            },
            "title": {
                "authentication app": "身份验证应用",
                "authentication email": "认证邮件",
                "is enabled": "已启用双因素认证。",
                "protect your account": "保护您的FOTA WEB账户"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "更改密码",
            "enter current password": "输入当前密码",
            "enter new password": "输入新密码",
            "hide password": "隐藏密码",
            "repeat new password": "重复新密码",
            "rules": {
                "lowercase letter": "至少包含一个小写字母（a-z）",
                "minimum characters": "至少12个字符",
                "new and current passwords must not match": "新密码与当前密码不得相同",
                "new passwords must match": "新密码必须匹配",
                "number": "至少一个数字",
                "passwords must match": "密码必须匹配",
                "special symbol": "至少包含一个特殊符号 (!@#$%^&*()-_=+)",
                "uppercase letter": "至少包含一个大写字母（A-Z）"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "显示密码"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "表统计",
        "statistics message": "表格筛选条件将影响下方显示的统计数据",
        "activity": "活动",
        "model": "模型",
        "firmware": "固件",
        "configuration": "配置",
        "statistics": "统计数据"
    },
    "Table": {
        "1_wire_authorization": "1线授权",
        "access group": "",
        "access groups": "",
        "access level": "访问级别",
        "accessories": "配件",
        "action": "操作",
        "action date": "操作日期",
        "assigned package": "指定配套",
        "attempt count": "尝试次数",
        "attribute": "属性",
        "attributes": "属性",
        "auto sync": "",
        "batch id": "批次ID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE固件",
        "bluetooth_authorization": "蓝牙授权",
        "bootloader": "引导加载程序",
        "can_adapter": "CAN总线适配器",
        "can adapter name": "CAN适配器名称",
        "can bootstring": "启动字符串",
        "can oem file package": "OEM文件包",
        "can oem file vehicle": "OEM车辆文件",
        "can package": "CAN协议配套",
        "can program number": "CAN程序编号",
        "can software date": "CAN软件数据",
        "can type": "CAN总线类型",
        "carrier module id": "模块ID",
        "carrier revision": "修订版",
        "carrier serial id": "序列ID",
        "carrier settings filename": "设置文件名",
        "carrier unit status": "状态",
        "carrier unit type": "单元类型",
        "changed at": "修改于",
        "change origin": "",
        "changes": "变更",
        "checkbox disabled": {
            "role": "静态角色不可编辑或删除。"
        },
        "child company": "<1>{{parentCompany}}</1><0>旗下子公司</0>",
        "child companies": "子公司",
        "code": "代码",
        "company": "公司",
        "company hierarchy": "公司层级结构",
        "company name": "公司名称",
        "compatibility": "兼容性",
        "configuration": "配置",
        "configuration details": "配置详情",
        "configuration type": "",
        "created at": "创建于",
        "created by": "创建者：",
        "date": "日期",
        "description": "描述",
        "device details": "设备详情",
        "device company": "设备公司",
        "device description": "设备描述",
        "device group": "设备组",
        "device imei": "设备 IMEI",
        "device model": "设备型号",
        "device seen at": "设备可见于",
        "device serial": "设备序列号",
        "devices": "设备",
        "devices count": "设备数量",
        "Done": "完成",
        "download at": "",
        "download file": "下载文件",
        "dtb": "DTB",
        "edit file": "编辑文件",
        "email": "电子邮件",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "任务组创建完成后，您即可在此处查看列表",
                    "changes": "一旦发生变更，您即可在此处查看变更列表",
                    "companies": "企业创建完成后，您即可在此处查看列表",
                    "configurationChanges": "",
                    "desktopLicenses": "桌面许可证创建完成后，您即可在此处查看列表",
                    "devices": "设备上传至FOTA WEB后，您即可在此处查看设备列表",
                    "files": "文件上传后，您将立即在此处看到文件列表",
                    "groups": "创建组后，您即可在此处查看组列表",
                    "offlineLicenses": "离线许可证创建后，您即可在此处查看列表",
                    "permissions": "用户权限分配完成后，您即可在此处查看权限列表",
                    "productCodes": "产品代码生成后，您即可在此处查看列表",
                    "roles": "角色创建完成后，您即可在此处查看角色列表",
                    "tasks": "任务创建后，您即可在此处查看任务列表",
                    "users": "用户添加后，您即可在此处查看列表"
                },
                "title": {
                    "batches": "任务组表格为空",
                    "changes": "变更表为空",
                    "companies": "公司列表为空",
                    "configurationChanges": "",
                    "desktopLicenses": "桌面许可证表格为空",
                    "devices": "设备列表为空",
                    "files": "文件表为空",
                    "groups": "组列表为空",
                    "offlineLicenses": "离线许可证表格为空",
                    "permissions": "权限表为空",
                    "productCodes": "产品代码表为空",
                    "roles": "角色表为空",
                    "tasks": "任务列表为空",
                    "users": "用户表为空"
                }
            },
            "no permission": {
                "description": "请联系您的管理员申请访问权限。",
                "title": "您没有权限查看此内容"
            },
            "no results found": {
                "description": "请尝试其他关键词或筛选条件以获取结果",
                "title": "未找到结果"
            },
            "button": {
                "add": {
                    "companies": "创建公司",
                    "devices": "添加设备",
                    "files": "上传文件",
                    "groups": "创建群组",
                    "productCodes": "添加产品代码",
                    "tasks": "创建任务",
                    "users": "邀请用户"
                },
                "reset view": "重置视图"
            }
        },
        "exausted autoscan limit": "自动扫描配额已耗尽，直至",
        "exausted vin parsing limit": "车辆识别码解析次数已达到上限",
        "expiration": "到期日",
        "expiration date": "到期日期",
        "expires at": "到期于",
        "expiry date": "到期日期",
        "field": "现场",
        "file": "文件",
        "file id": "文件ID",
        "files": "文件",
        "file type": "文件类型",
        "filter by": "按以下条件筛选：",
        "firmware": "固件",
        "general": "通用",
        "general data": "通用数据",
        "gnss version": "GNSS版本",
        "group": "组",
        "groups": "设备组",
        "group vip status": "",
        "gsm number": "GSM号码",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "<1>FMx平台</1> - FMx（FMB、FMU、FMC、FMM）、FMT、FMP、TAT、MSP、TFT、TST、GH（GH5200）及TMT型号。",
                "ft platform": "<1>FT平台</1> - FTx与ATx型号。",
                "legacy platform": "<1>传统平台</1> - FM系列（不含FM4001和FM3010型号）、FMA系列及GH系列（GH4000型号）。",
                "title": "远程信息处理设备的平台生成"
            },
            "visibility": "<2>标记为<1>内部</1>的变更对客户不可见。</2><2>由于设备变更可能包含可见与隐藏数据，<1>请勿在外部沟通中分享截图或细节</1>。</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "信息",
        "interface": "接口",
        "invited by": "应邀",
        "items": "项目",
        "last checked at": "最后检查于",
        "last sign in": "最后登录时间",
        "last status update": "最后状态更新",
        "last used at": "最后使用于",
        "license disabled": "已禁用",
        "license enabled": "已启用",
        "license key": "许可证密钥",
        "license name": "",
        "links": "链接",
        "manual_geofence_scenarios": "手动地理围栏场景",
        "message": "消息",
        "model": "模型",
        "model task type support": {
            "false": "不支持",
            "true": "支持"
        },
        "modem version": "调制解调器版本",
        "name": "名称",
        "new value": "新价值",
        "next task": "下一步任务",
        "no changes": "无需修改。",
        "no company name": "暂无公司名称",
        "no details": "无详细信息",
        "no file": "无文件",
        "no imei available": "无IMEI可用",
        "no model": "无模型",
        "no parent company": "该公司没有母公司。",
        "no tasks": "该设备无任务。",
        "number": "编号",
        "obd": "OBD",
        "obd chip firmware version": "OBD芯片固件版本",
        "of": "的",
        "offline licenses tab disabled": "离线许可证对禁用的桌面许可证不可用。",
        "origin": "",
        "original value": "原始价值",
        "other information": "其他信息",
        "page of": "页面",
        "parent company": "母公司",
        "permission count": "权限数量",
        "platform": "平台",
        "Price": "价格",
        "product code": "产品代码",
        "program number": "程序编号",
        "property": "属性",
        "queue": "队列",
        "receiving company": "接收公司",
        "revision": "修订版",
        "role": "角色",
        "role name": "角色名称",
        "rows per page": "每页行数",
        "running": "运行中",
        "schedule": "计划",
        "seen at": "在以下平台可见",
        "select row": "选择一行查看详情",
        "send sms": "发送短信",
        "serial": "序列号",
        "show details": {
            "desktopLicenses": "查看桌面版许可证详情",
            "devices": "显示设备详情",
            "batches": "显示任务组详情",
            "tasks": "显示任务详情",
            "companies": "显示公司详情"
        },
        "sim": "SIM",
        "size": "尺寸",
        "software date": "软件日期",
        "source company": "源公司",
        "spec_id": "规格 ID",
        "status": "状态",
        "status id": "状态ID",
        "status name": "状态名称",
        "supported task types": "支持的任务类型",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "表格列",
        "target company": "目标公司",
        "task id": "任务ID",
        "task queue": "任务队列",
        "tasks": "任务",
        "task type": "任务类型",
        "tct web support": "TCT web支持",
        "total": "总计",
        "type": "类型",
        "updated at": "更新于",
        "updated by": "更新者",
        "unknown": "未知",
        "user cannot be deleted": "用户账户不可删除。",
        "user cannot be edited": "用户无法被编辑。",
        "user cannot delete himself": "用户无法删除自己的个人资料。",
        "user date statuses": {
            "expired": "已过期",
            "expires": "到期",
            "never expires": "永不过期",
            "sent": "发送"
        },
        "user email": "用户邮箱",
        "user invitation cannot be cancelled": "用户邀请无法取消。",
        "user invitation cannot be resent": "用户邀请无法重新发送。",
        "user sent configuration": "",
        "user statuses": {
            "Active": "活跃",
            "Inactive": "非活动状态",
            "InvitationExpired": "已过期的邀请",
            "InvitationPending": "待邀请"
        },
        "users": "用户",
        "value from": "价值体现在",
        "value to": "价值在于",
        "view all roles": "查看全部 ({{count}})",
        "vin": "VIN",
        "vip status": "VIP身份",
        "visibility": "可视性"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "权限信息",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "配件接口名称。",
                    "type": "连接的配件类型。"
                },
                "can": {
                    "assigned package": "分配给设备的OEM软件包。",
                    "can oem file package": "上次连接时报告的OEM软件包。",
                    "can oem file vehicle": "上次连接时报告的OEM车辆配置。",
                    "dtb": "",
                    "firmware": "CAN固件版本。"
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "最新接收到的CAN适配器启动字符串，包含当前数据及适配器程序编号。",
                    "program number": "CAN适配器的程序编号。",
                    "revision": "",
                    "software date": "CAN适配器的软件日期。",
                    "type": "CAN适配器的类型。"
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "最后发送的1-Wire授权列表文件名。",
                    "bluetooth_authorization": "最后发送的蓝牙授权列表文件名。",
                    "main configuration": "最后发送的主配置文件名称。",
                    "manual_geofence_scenarios": "上次发送的手动地理围栏列表文件名。"
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "上次连接时报告的BLE固件版本。",
                    "bluetooth password": "",
                    "bootloader": "设备引导程序在最近一次连接时报告的版本号。",
                    "company": "拥有该设备的公司。",
                    "configuration": "最后发送的配置文件名称。",
                    "description": "设备描述（用户自定义）。",
                    "dtb": "最后连接时报告的设备树 Blob 版本。",
                    "firmware": "设备在最近一次连接时报告的固件版本。",
                    "gnss version": "上次连接时报告的GNSS版本。",
                    "group": "该设备所属的设备组。",
                    "product code": "设备产品代码。",
                    "serial": "设备序列号。"
                },
                "obd": {
                    "obd chip firmware version": "上次连接时报告的OBD芯片固件版本。",
                    "vin": "用于识别特定机动车的唯一17位字符代码。"
                },
                "sim": {
                    "gsm number": "与设备关联的公共电话号码。",
                    "iccid": "用于标识SIM卡的唯一序列号。",
                    "imsi": "移动网络用户的唯一标识符。"
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "用户创建的日期和时间。",
                    "id": "用户的唯一标识符。",
                    "invited by": "创建邀请的用户的电子邮件地址。",
                    "role": "用户被分配的角色。",
                    "updated at": "最后一次用户更新的日期和时间。"
                }
            }
        },
        "user details": "用户详情"
    },
    "Task groups": {
        "all": "全部",
        "bulk type": {
            "CompanyBulkDelete": "删除公司",
            "DeviceBulkCreate": "添加设备",
            "DeviceBulkDelete": "删除设备",
            "DeviceBulkUpdate": "更新设备",
            "FileBulkDelete": "删除文件",
            "GroupBulkDelete": "删除组",
            "TaskBulkCreate": "创建任务",
            "TaskBulkUpdate": "取消任务",
            "UserBulkDelete": "删除用户"
        },
        "pending approval": "待审批",
        "already approved": "已获批准",
        "no approval required": "无需审批",
        "total objects": "总对象数",
        "total tasks": "总任务数"
    },
    "Task status": {
        "0": "待处理",
        "1": "运行中",
        "2": "已完成",
        "3": "已完成但存在错误",
        "4": "已取消",
        "5": "失败",
        "6": "已过期",
        "7": "等待审批",
        "8": "验证",
        "task count": {
            "0": "待办事项",
            "1": "运行任务",
            "3": "已完成但存在错误的任务",
            "5": "失败任务"
        },
        "verified tooltip title": "任务已成功完成并经设备验证。"
    },
    "Tasks": {
        "0": "该任务已加入队列，当前处于待处理状态。",
        "1": "该任务当前正在运行。",
        "2": "任务已成功完成。",
        "3": "任务已完成，但出现了一些错误。",
        "4": "任务已被取消。",
        "5": "任务执行失败。",
        "6": "该任务未在规定时间内完成。"
    },
    "Tct": {
        "edit configuration": "编辑配置",
        "no editable configurations": "不包含可编辑配置文件的上传",
        "open tct": "开放TCT web版本",
        "open tct description": "您可选择在TCT web版本中创建新配置，或通过FOTA WEB编辑现有配置文件。",
        "select configuration file": "在TCT web端选择您要编辑的配置文件。",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web版仅面向企业级高级用户开放。"
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
